<template>
  <div>
    <div class="page_title">常见问题</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div
          style="margin-bottom:20px"
          class="flex_between"
        >
          <span>
            <span style="margin-right:10px">问题分组</span>
            <el-select
              v-model="group_type_id"
              placeholder="请选择"
              @change="getList"
            >
              <el-option
                label="全部"
                :value="-1"
              ></el-option>
              <el-option
                v-for="item in groupTypeList"
                :key="item.group_type_id"
                :label="item.group_type_name"
                :value="item.group_type_id"
              >
              </el-option>
            </el-select>
          </span>
          <el-button
            type="primary"
            @click="AddType"
          >添加问题类型</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%;min-width:1000px;"
            :header-cell-style="{background:'#F5F5F5'}"
          >
            <el-table-column
              label="问题类型"
              prop="title"
            ></el-table-column>
            <el-table-column
              label="问题分组"
              prop="group_type_name"
            ></el-table-column>
            <el-table-column
              label="问题数量"
              prop="article_count"
            ></el-table-column>
            <el-table-column
              label="修改时间"
              prop="update_time"
            ></el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="toDetail(scope.row.group_id)"
                  type="text"
                  size="medium"
                >编辑</el-button>
                <el-button
                  @click="delQue(scope.row.group_id)"
                  type="text"
                  size="medium"
                >删除</el-button>
              </template>
            </el-table-column>

            <el-table-column label="排序">
              <template slot-scope="scope">
                <el-button
                  @click="updateSort(scope.$index,1)"
                  size="medium"
                  type="text"
                  icon="el-icon-upload2"
                  style="font-size:20px"
                ></el-button>

                <el-button
                  @click="updateSort(scope.$index,2)"
                  size="medium"
                  type="text"
                  icon="el-icon-download"
                  style="font-size:20px"
                ></el-button>

                <el-button
                  @click="updateSort(scope.$index,3)"
                  size="medium"
                  type="text"
                  icon="el-icon-top"
                  style="font-size:20px"
                ></el-button>
                <el-button
                  @click="updateSort(scope.$index,4)"
                  size="medium"
                  type="text"
                  icon="el-icon-bottom"
                  style="font-size:20px"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 添加问题类型弹窗 -->
    <el-dialog
      title="添加问题类型"
      :visible.sync="addDia"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="padding:30px 20px 20px">
        <div>
          <span>问题类型</span>
          <el-input
            v-model="addData.title"
            maxlength="10"
            style="margin-left:10px;width:200px"
          ></el-input>
        </div>
        <div style="margin:16px 0 40px">
          <span>问题分组</span>
          <el-select
            v-model="addData.group_type_id"
            placeholder="请选择"
            style="margin-left:10px;width:200px"
          >
            <el-option
              v-for="item in groupTypeList"
              :key="item.group_type_id"
              :label="item.group_type_name"
              :value="item.group_type_id"
            >
            </el-option>
          </el-select>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            plain
            @click="addDia = false"
            style="width: 80px"
            size="medium"
          >关闭</el-button>
          <el-button
            type="primary"
            style="width: 80px"
            size="medium"
            @click="submit"
          >保存</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import imgtext from '../../../api/imgtext';
import platform from '../../../api/platform';
export default {
  data() {
    return {
      detail: {},
      edit: false,
      tableData: [],
      groupTypeList: [],
      group_type_id: -1,
      addDia: false,
      addData: {
        group_id: 0,
        group_type_id: '',
        title: ''
      }
    };
  },

  methods: {
    //获取图文信息
    getList() {
      let group_type_id = this.group_type_id;
      this.axios
        .post('platform/article/getArticleGroupList', { group_type_id })
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.update_time = platform.timestampToTime(item.update_time);
              return item;
            });
          }
        });
    },
    //获取问题分组列表配置
    getGroupTypeList() {
      this.axios
        .post('platform/article/getArticleGroupTypeList')
        .then((res) => {
          if (res.code == 0) {
            this.groupTypeList = res.data.list;
          }
        });
    },
    //排序
    updateSort(index, status) {
      let data = this.tableData[index];
      this.tableData.splice(index, 1);
      //置顶
      if (status == 1) {
        this.tableData.splice(0, 0, data);
      }
      //置底
      if (status == 2) {
        this.tableData.push(data);
      }
      //上移
      if (status == 3) {
        this.tableData.splice(index - 1, 0, data);
      }
      //下移
      if (status == 4) {
        this.tableData.splice(index + 1, 0, data);
      }
      let list = [];
      list = this.tableData.map((item) => {
        item = _.pick(item, ['group_id', 'sort']);
        return item;
      });
      imgtext.editArticleGroupSort({ list }).then((res) => {
        if (res.code == 0) {
          this.getList();
        }
      });
    },
    //添加问题类型
    AddType() {
      this.addData = {
        group_id: 0,
        group_type_id: '',
        title: ''
      };
      this.addDia = true;
    },
    submit() {
      if (!this.addData.group_type_id || !this.addData.title) {
        this.$message.error('请填写完整再提交');
        return false;
      }
      let data = this.addData;
      imgtext.saveArticleGroupInfo(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('保存成功');
          this.addDia = false;
          this.getList();
        }
      });
    },
    //删除问题类型
    delQue(group_id) {
      this.$confirm(
        '该问题类型的全部问题将被一起删除，确定要删除吗？',
        '提示消息',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      ).then(() => {
        imgtext
          .deleteArticleGroupInfo({ group_id })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('删除成功');
              this.getList();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    //问题类型item
    toDetail(group_id) {
      this.$router.push({
        path: 'questionitem',
        query: {
          group_id
        }
      });
    }
  },
  created() {
    this.getList();
    this.getGroupTypeList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
</style>

